export const GODADDY_PL_ID = 1;
